import UsedInSection from './UsedInSection';

export default UsedInSection;
